/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface OauthLoginRequest
 */
export interface OauthLoginRequest {
  /**
   * OAuth grant type
   * @type {string}
   * @memberof OauthLoginRequest
   */
  grant_type: OauthLoginRequestGrantTypeEnum
  /**
   * ID OAuth-клиента
   * @type {string}
   * @memberof OauthLoginRequest
   */
  client_id: string
  /**
   * Секрет OAuth-клиента
   * @type {string}
   * @memberof OauthLoginRequest
   */
  client_secret: string
  /**
   * Электронная почта (grant password)
   * @type {string}
   * @memberof OauthLoginRequest
   */
  username?: string
  /**
   * Пароль (grant password)
   * @type {string}
   * @memberof OauthLoginRequest
   */
  password?: string
  /**
   * Авторизационный код (grant authorization_code)
   * @type {string}
   * @memberof OauthLoginRequest
   */
  code?: string
  /**
   * URI редиректа (grant authorization_code)
   * @type {string}
   * @memberof OauthLoginRequest
   */
  redirect_uri?: string
  /**
   *
   * @type {string}
   * @memberof OauthLoginRequest
   */
  scope?: string
}

/**
 * @export
 * @enum {string}
 */
export enum OauthLoginRequestGrantTypeEnum {
  Password = 'password',
  AuthorizationCode = 'authorization_code',
}

/**
 * Check if a given object implements the OauthLoginRequest interface.
 */
export function instanceOfOauthLoginRequest(
  value: object
): value is OauthLoginRequest {
  if (!('grant_type' in value) || value['grant_type'] === undefined)
    return false
  if (!('client_id' in value) || value['client_id'] === undefined) return false
  if (!('client_secret' in value) || value['client_secret'] === undefined)
    return false
  return true
}

export function OauthLoginRequestFromJSON(json: any): OauthLoginRequest {
  return OauthLoginRequestFromJSONTyped(json, false)
}

export function OauthLoginRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OauthLoginRequest {
  if (json == null) {
    return json
  }
  return {
    grant_type: json['grant_type'],
    client_id: json['client_id'],
    client_secret: json['client_secret'],
    username: json['username'] == null ? undefined : json['username'],
    password: json['password'] == null ? undefined : json['password'],
    code: json['code'] == null ? undefined : json['code'],
    redirect_uri:
      json['redirect_uri'] == null ? undefined : json['redirect_uri'],
    scope: json['scope'] == null ? undefined : json['scope'],
  }
}

export function OauthLoginRequestToJSON(value?: OauthLoginRequest | null): any {
  if (value == null) {
    return value
  }
  return {
    grant_type: value['grant_type'],
    client_id: value['client_id'],
    client_secret: value['client_secret'],
    username: value['username'],
    password: value['password'],
    code: value['code'],
    redirect_uri: value['redirect_uri'],
    scope: value['scope'],
  }
}
